import React from 'react';
import Modal from '../Modal';
import { claim } from '../../Cureus/EditorialDataTableLoader';

const ApprovalEditorOneMatchModal = ({notifications, currentUserId, handleModalClose}) => {

  const updateNotification = (notificationId, targetId) => {
    $.ajax({
      type: 'put',
      url: `/users/${currentUserId}/notifications/${notificationId}/update_notification`,
      success: function(res) {
        claim(targetId, 'approval', false, () => {
          handleModalClose(notifications);
        });
      }
    })
  }

  return (
    <div data-reveal className='reveal-modal' id='ae-one-match-modal'>
      <div className='modal-body'>
        <div className='modal-close'>
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
      </div>
      <div className='modal-content'>
        <h4 className='title'>{notifications[0].title}</h4>
        <h4 className='message'>{notifications[0].message}</h4>
        <div className='notifications-container'>
          <table>
            <thead>
              <tr>
                <th>Submitting Author</th>
                <th>Tier</th>
                <th>Title</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((notification, index) => {
                return (
                  <tr key={index}>
                    <td dangerouslySetInnerHTML={{__html: notification.submitter}}></td>
                    <td dangerouslySetInnerHTML={{__html: notification.tier}}></td>
                    <td>{notification.target_title}</td>
                    <td>
                      <a className='button no-margin' onClick={() => updateNotification(notification.id, notification.target_id)}>{notification.btn_text}</a>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ApprovalEditorOneMatchModal;